import "../../../assets/scss/instance-detail-modal-style.scss";
import React, { useState } from "react";
import { Modal } from "antd";
import { InstanceCardInterface } from "../../utility/interface/instance-card";
import { CloseOutlined, CopyOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface Props {
  visible: boolean;
  onClose: () => void;
  instance: InstanceCardInterface | null;
}

export const InstanceDetailModal: React.FC<Props> = ({
  visible,
  onClose,
  instance,
}) => {
  const { t } = useTranslation();
  if (!instance) return null;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={520}
      className="instance-detail-modal"
    >
      <div className="modal-header">
        <h2>{instance?.product_name}</h2>
        <CloseOutlined onClick={onClose} className="close-icon" />
      </div>

      <div className="modal-body">
        <div className="detail-grid">
          <div>
            <span>{t("Applications")}</span>
            <strong>{instance?.template_name}</strong>
          </div>
          <div>
            <span>{t("GPU Amount")}</span>
            <strong>{instance?.gpu_count} GPU</strong>
          </div>
          <div>
            <span>{t("GPU RAM")}</span>
            <strong>96 GB</strong>
          </div>
          <div>
            <span>{t("Disk Storage")}</span>
            <strong>252 GB</strong>
          </div>
          <div>
            <span>{t("CPU")}</span>
            <strong>AMD EPYC 7W83 64-Core Processor</strong>
          </div>
          <div>
            <span>{t("Effective RAM")}</span>
            <strong>1006 GB</strong>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <p>
          <span>SSH Command :</span> <a href="#">{instance?.ssh_url}</a>{" "}
          <CopyOutlined
            className="copy-icon"
            onClick={() => navigator.clipboard.writeText(instance.ssh_url!)}
          />
        </p>
        <p>
          <span>SSH Password :</span>
          <span>************</span>
          <CopyOutlined
            className="copy-icon"
            onClick={() =>
              navigator.clipboard.writeText(instance.ssh_password!)
            }
          />
        </p>
      </div>
    </Modal>
  );
};
